import React from 'react';
import { Field, reduxForm, formValues } from 'redux-form';
import { Alert, Form } from 'react-bootstrap';
import { DateTimeInput, Input, Static } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import PaidBackFields from '../reports/cancellationCreditNotes/PaidBackFields';

const min0 = validators.minValue(0);

// only once something is being refunded
const RefundPaidBackFields = formValues('refundedAmount')(({ refundedAmount }) => Number(refundedAmount) > 0 ? <PaidBackFields /> : null);

const MarkAsCancelledForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, initialValues,  paymentMethod, showWarning, endsSubscription, removesFrom, t }) => {
	const warningMessage = t(`PaymentMethod_${paymentMethod}_CancelRecurringWarning`);
	// where the date decides what's removed, it's the first day without lessons/sessions
	let dateHelp = null;
	if (removesFrom === 'lessons') {
		dateHelp = t(endsSubscription ? 'PaymentHistory_LessonsRemovedFrom_SubscriptionHelp' : 'PaymentHistory_LessonsRemovedFrom_Help');
	} else if (removesFrom === 'sessions') {
		dateHelp = t('PaymentHistory_SessionsRemovedFrom_Help');
	}
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{showWarning && warningMessage && <Alert bsStyle='warning'><div dangerouslySetInnerHTML={{ __html: warningMessage }} /></Alert>}
			{endsSubscription && <Alert bsStyle='warning'>{t('PaymentHistory_MarkAsCancelled_SubscriptionWarning')}</Alert>}
			<Field name='cancellationDate' component={DateTimeInput} showTime={false} step={1} disabled={isReadonly} horizontal required label={t('PaymentHistory_CancellationDate')} help={dateHelp} validate={[validators.required]} />
			<Field name='outstandingTotal' component={Static} formatType='double' horizontal label={t('PaymentHistory_Outstanding')}
				help={t('PaymentHistory_Outstanding_Help')} />
			<Field name='refundedAmount' component={Input} disabled={isReadonly} horizontal label={t('PaymentHistory_Refund')}
				validate={[validators.number, min0]} help={t('PaymentHistory_Refund_Help')} />
			{!isReadonly && <RefundPaidBackFields />}
		</Form>
	);
};

export default reduxForm({ form: 'markAsCancelled' })(withTranslation()(MarkAsCancelledForm));